import PropTypes from "prop-types"
import React from "react"

class BoatUSToggle extends React.Component {
  constructor(props) {
    super(props)
    this.no = this.no.bind(this)
    this.yes = this.yes.bind(this)
  }

  componentDidMount() {
    this.props.setHeader("BoatUS Membership")
  }

  no() {
    this.props.setGlobalState({ choseBoatUS: false })
    this.props.routeTo("next")
  }

  yes() {
    this.props.setGlobalState({ choseBoatUS: true })
    this.props.routeTo("BoatUS")
  }

  render() {
    return (
      <div id="boatUSToggle" className="boatus-toggle">
        <h3 className="text-center text-lg">
          Do you have a BoatUS Membership?
        </h3>
        <div style={{ marginTop: "10px" }} className="btn-group" role="group">
          <button
            id="boatUSYesSelection"
            autoFocus
            className="btn btn-primary"
            type="button"
            onClick={this.yes}
          >
            Yes
          </button>
          <button
            id="boatUSNoSelection"
            className="btn btn-secondary"
            type="button"
            onClick={this.no}
          >
            No
          </button>
        </div>
        <p style={{ marginTop: "15px" }}>
          If you are a BoatUS member, you can add your membership information to
          get discounts at this location.
        </p>
      </div>
    )
  }
}

BoatUSToggle.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setGlobalState: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
}

export default BoatUSToggle
